import '../base';
import PROFESSORS from './teaching.data';

// import './teaching.scss';

let activeFilter = null;
let allProfessorEl = null;
let professorElements = {};

function filterByProfessor(professorName) {
  const currentProfessor = activeFilter.innerText;
  if (professorName == currentProfessor) {
    return;
  }
  if (currentProfessor == 'All Professors') {
    for (const prof of PROFESSORS) {
      professorElements[prof.professor].classList.add('is-hidden');
    }
  } else {
    professorElements[currentProfessor].classList.add('is-hidden');
  }
  if (professorName == 'All Professors') {
    for (const prof of PROFESSORS) {
      professorElements[prof.professor].classList.remove('is-hidden');
    }
  } else {
    professorElements[professorName].classList.remove('is-hidden');
  }
}

function createCourseElement(course) {
  const courseEl = document.createElement('div');
  courseEl.classList.add('columns');
  courseEl.innerHTML = `
    <div class="column is-one-quarter">
      ${course.event}
    </div>
    <div class="column">
      <a href="${course.url}">${course.title}</a>
    </div>
  `;
  return courseEl;
}

function createProfessorElement(professor) {
  const professorEl = document.createElement('div');
  const titleEl = document.createElement('p');
  titleEl.classList.add('title', 'is-4');
  titleEl.innerText = professor.professor;
  professorEl.appendChild(titleEl);
  for (const course of professor.courses) {
    const courseEl = createCourseElement(course);
    professorEl.appendChild(courseEl);
  }
  return professorEl;
}

document.addEventListener('DOMContentLoaded', function onLoaded() {
  document.removeEventListener('DOMContentLoaded', onLoaded);
  const filters = document.getElementsByClassName('svl-teaching--professor-filter');
  for (const filter of filters) {
    if (filter.classList.contains('is-active')) {
      activeFilter = filter;
      allProfessorEl = filter;
    }
    filter.onclick = function() {
      this.classList.add('is-active');
      activeFilter.classList.remove('is-active');
      filterByProfessor(this.innerText);
      activeFilter = this;
    };
  }

  const content = document.getElementById('svl-teaching--content');
  for (const professor of PROFESSORS) {
    const profEl = createProfessorElement(professor);
    professorElements[professor.professor] = profEl;
    content.appendChild(profEl);
  }
});
